// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"8bc1bf64","4107":"c0ad6e53"}[chunkId] + ".chunk.css";
};